module.exports = __webpack_public_path__ + "static/media/business.d5fc6a22.svg";